import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { EditPasswordlessAccessModel } from 'app/library/passwordless-access/models/edit-passwordless-access';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import {
    CreateModulePasswordlessAccess,
    CreateModulePasswordlessAccessFailure,
    CreateModulePasswordlessAccessSuccess,
    DeleteModulePasswordlessAccess,
    DeleteModulePasswordlessAccessFailure,
    DeleteModulePasswordlessAccessSuccess,
    FetchModulePasswordlessAccesses,
    FetchModulePasswordlessAccessesFailure,
    FetchModulePasswordlessAccessesSuccess,
    UpdateModulePasswordlessAccess,
    UpdateModulePasswordlessAccessFailure,
    UpdateModulePasswordlessAccessSuccess,
} from '../../actions';
import { CreateModulePasswordlessAccessModel } from '../../models/create-module-passwordless-access';
import { ModulePasswordlessAccess } from '../../models/module-passwordless-access.model';
import { ModulePasswordlessAccessState } from '../../models/module-passwordless-access.state';

@Injectable()
export class ModulePasswordlessAccessService {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getModulePasswordlessAccesses(): ModulePasswordlessAccess[] {
        return this._store.selectSnapshot(ModulePasswordlessAccessState.getEntities);
    }

    fetchModulePasswordlessAccesses(moduleId: string, pageSize: number, pageNumber: number, search: string): Promise<boolean> {
        this._store.dispatch(new FetchModulePasswordlessAccesses({ moduleId, pageSize, pageNumber, search }));

        return this._actionHelper.race(FetchModulePasswordlessAccessesSuccess, FetchModulePasswordlessAccessesFailure).toPromise();
    }

    async createModulePasswordlessAccess(entity: CreateModulePasswordlessAccessModel): Promise<boolean> {
        this._store.dispatch(new CreateModulePasswordlessAccess(entity));

        return await this._actionHelper.race(CreateModulePasswordlessAccessSuccess, CreateModulePasswordlessAccessFailure).toPromise();
    }

    async updateModulePasswordlessAccess(entity: EditPasswordlessAccessModel): Promise<boolean> {
        this._store.dispatch(new UpdateModulePasswordlessAccess(entity));

        return await this._actionHelper.race(UpdateModulePasswordlessAccessSuccess, UpdateModulePasswordlessAccessFailure).toPromise();
    }

    async deleteModulePasswordlessAccess(ids: string[]): Promise<boolean> {
        this._store.dispatch(new DeleteModulePasswordlessAccess(ids));

        return await this._actionHelper.race(DeleteModulePasswordlessAccessSuccess, DeleteModulePasswordlessAccessFailure).toPromise();
    }
}
